import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import SnippetTemplate from './SnippetTemplate';

export class Template extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  showCard = () => {
    return {
      display: !this.props.editor.showEmailSetting ? 'none' : '',
    };
  };

  showTemplateForm = () => {
    const { projectId, editor, actions, snippetId, version } = this.props;
    return (
      <SnippetTemplate
        projectId={projectId}
        editor={editor}
        version={version}
        actions={actions}
        currentOpenSnippetId={snippetId}
      />
    );
  };

  render() {
    const snippet = this.props.editor.selectedSnippet;
    return (
      <div className="gjs-mdl-container" style={this.showCard()}>
        <div className="gjs-mdl-dialog gjs-one-bg gjs-two-color">
          <div className="gjs-mdl-header">
            <div className="gjs-mdl-title">
              {snippet && snippet.name ? `${snippet.name}` : 'Create New Snippet'}
            </div>
            <div
              className="gjs-mdl-btn-close"
              onClick={() => this.props.actions.toggleEmailSetting()}
              data-close-modal=""
            >
              ⨯
            </div>
          </div>
          <div className="gjs-mdl-content">
            <div id="gjs-mdl-c">{snippet && this.showTemplateForm()}</div>
          </div>
          <div className="gjs-mdl-collector"></div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Template);
